<template>
<div id="app">

  <div class="margin-center" style="min-width: 1220px;width: 100%;">
    <div v-for="(item, index) in parts" :key="index" style="height:164px;margin-bottom: 10px;">
      <el-image style="width:100%;height:100%;" :src="item.ImageUrl" fit="cover"></el-image>
    </div>
  </div>

  <div class=" bg-white margin-center   margin-top-15 backgroud" style="padding-top:10px;min-height: 550px;">
    <!-- <div v-if="length>1" class="  width flex flex-wrap bg-white " style="margin:0px auto 10px">
      <p @click="checkCatalogsItem(index)" v-for="(item, index) in catalogs" :key="index" class="font-size-16   padding-l-r-20" :class="checkIndex == index?'font-color-red':'font-color-666-red'" style="line-height:30px;height: 30px; cursor: pointer;text-decoration:none">{{item.Name}}</p>
    </div> -->
    <div class="flex flex-wrap">
      <div v-for="(item, index) in dataList" :key="index" style="width: 280px;height: 254px; overflow: hidden;margin-left:20px; position: relative;" @click="clickVideo(item.Id,0)">
        <div style=" width: 280px;height: 168px;">
          <img style=" width: 280px;height: 168px;" :src="item.Image"  alt="">
        </div>
        <div class="backhover">
          <!-- :style="{backgroundImage:'url('+item.Image+')'}" -->

          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div>
        <div class="title">
          <img v-if="item.HasPPT" src="../../assets/img/ppt.png" alt="">
          <img v-if="item.HasWord" src="../../assets/img/word.png" alt="">
          <p :title="item.Title" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;cursor: pointer;">{{item.Title}}</p>

        </div>
        <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px;">主讲人：{{item.Lecturer}}</p>
      </div>
    </div>
  </div>
  <div style=" margin-top: 20px; ">

    <el-pagination v-if="totalPage>1" :current-page.sync="currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="1" layout="prev, pager, next" :total="totalPage">
    </el-pagination>
  </div>
  <Bottom></Bottom>
</div>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {
      checkIndex: 0,
      parts: [],
      catalogs: [{
        'Id': 2997,
        'Name': '全部',
        'ParentId': 1,
        'Level': 1,
        'Order': 'amet'
      }],
      cateId: 3239,
      currentPage: 1,
      dataList: [],
      totalPage: 1
    }
  },
  computed: {
    length () {
      return this.catalogs.length
    }
  },
  created () {
    this.getParts()
    // this.getCatalogs();
    this.getCourseList(1)
  },
  methods: {
    checkCatalogsItem (index) {
      if (this.checkIndex != index) {
        this.checkIndex = index
        this.getCourseList(1)
        this.currentPage = 1
      }
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`);
      window.scrollTo(0, 0)
      // this.currentPage = val
      this.getCourseList(val)
    },

    // 获取头部部件
    getParts () {
      var that = this
      this.getRequest('api/v1/parts/', {
        CatalogId: this.cateId
      }).then(data => {
        if (data.IsSuccess) {
          that.parts = data.Data
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    getCatalogs () {
      var that = this
      this.getRequest('api/v1/catalogs/', {
        Id: this.catalogs[this.checkIndex].Id
      }).then(data => {
        if (data.IsSuccess) {
          var list = []
          for (var i = 0; i < data.Data.length; i++) {
            if (data.Data[i].Level == 2) {
              list.push(data.Data[i])
            }
          }
          list = that.catalogs.concat(list)
          that.catalogs = list
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    getCourseList (index) {
      var that = this
      this.getRequest('api/v1/courses/', {
        CatalogId: this.cateId,
        PageIndex: index,
        PageSize: 16
      }).then(data => {
        if (data.IsSuccess) {
          that.dataList = data.Data.Courses
          that.totalPage = data.Data.TotalPage
        } else {
          this.$message.error(data.Message)
        }
      })
    },

    clickVideo: function (courseId, videoId) {
      // this.$router.resolve({
      //     name: 'video',
      //     params: {
      //         courseId: courseId,
      //         videoId: videoId
      //     }
      // })
      let routeData = this.$router.resolve({
        name: 'video',
        params: {
          sizheng: 'n',
          courseId: courseId,
          videoId: videoId
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}

.title {
  display: flex;
  margin-top: 15px;
  align-items: center;
}

.title img {
  width: 14px;
  height: 16px;
  margin-right: 5px;
}

.title p {
  flex: 1;
}

.backhover {
  width: 280px;
  height: 168px;
  overflow: hidden;
  margin-top: -168px;
  background-size: cover;
  background-repeat: no-repeat;
}

.backhover div {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.backhover .subMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  z-index: 0;
}

.backhover .playIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 6;
  opacity: 0;
  margin: -30px 0 0 -30px;
  width: 60px;
  height: 60px;
  background: url(https://h5.cdn.bjadks.com/website/wsbgt-zt/999-linshi_szk/play-icon1.png) no-repeat;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
}

.backhover div:hover .subMask {
  display: block;
  z-index: 5;
}

.backhover div:hover .playIcon {
  z-index: 6;
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/views/redfilm/redfilm.vue